export default __webpack_public_path__ + "static/media/red-dot.70cf5fad.gif";